
class TextOptionPresenter {

  errorMessage = 'Accepted characters: A-Z, 0-9, spaces, apostrophes and periods.';
  regexRestrictions = /^[a-z0-9 \.\']+$/im;

  constructor(element, rules) {

    this.element = element;
    this.parent = element.parentElement;

    if (rules && rules.errorMessage) {
      this.errorMessage = rules.errorMessage;
    }
    if (rules && rules.regex) {
      this.regexRestrictions = new RegExp(rules.regex, 'im');
    }
    this.isValid = false;
    this.insertErrorMessage();
  }

  isOptionValid() {
    if (this.element.value.length == 0) {
      this.isValid == true
    } else {
      this.isValid = this.regexRestrictions.test(this.element.value);
      this.updateErrorMessage();
    return this.isValid;
    }
  }

  insertErrorMessage() {
    this.errorMessageEl = document.createElement('p');
    this.errorMessageEl.innerText = this.errorMessage;
    this.errorMessageEl.classList.add('accepted_chars');
    this.errorMessageEl.classList.add('error-text');
    this.hideErrorMessage();

    this.parent.insertBefore( this.errorMessageEl, this.element);
  }

  updateErrorMessage() {
    if (this.isValid) {
      this.hideErrorMessage();
    } else {
      this.showErrorMessage();
    }
  }

  showErrorMessage() {
    this.errorMessageEl.style.display = 'block';
  }

  hideErrorMessage() {
    this.errorMessageEl.style.display = 'none';
  }
}

export default TextOptionPresenter;
